$(document).ready(function(){

  function scroll_nav(){
    var scroll = $(window).scrollTop();
    var nav = $('.s-nav');
    if (nav.hasClass('s-nav--opaque')){
      if (scroll < 80){
        nav.removeClass('s-nav--opaque');
      }
    } else {
      if (scroll >= 80){
        nav.addClass('s-nav--opaque');
      }
    }
  }

  scroll_nav();
  $(window).scroll(function(){
    scroll_nav();
  });

  $('.s-nav__burger').click(function(){
    $('.s-nav').toggleClass('s-nav--open');
    $('.s-body').toggleClass('s-body--open');
  });

});